export const TARGET_ORIGIN = 'https://d1ux9mupljc68q.cloudfront.net’;';
export const TARGET_PATH = '/1/index.html’;';
